import { theme } from 'Assets/Styles/theme'

export default ({ props }) => {
  const accentColor = props.color || theme.colors.primary

  return {
    headerPart: {
      padding: '24px 46px 0',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
    },
    helper: {
      cursor: 'pointer',
      display: 'flex',
      color: `${accentColor}`,
    },
    icon: {
      marginRight: '6px',
    },

    title: {
      color: accentColor,
      fontSize: '24px',
      display: 'flex',
    },
    codes: {
      marginLeft: '44px',
      marginRight: '20px',
      marginTop: '24px',
      display: 'grid',
      gridTemplateColumns: '7fr 3fr',
      gap: '30px',
    },
    button: {
      marginRight: '12px',
    },
    tip: {
      color: '#9B9B9B',
      cursor: 'pointer',
    },
    controlsBlock: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'flex-end',
    },

    tooltipWrapper: {
      position: 'relative',
    },
    tooltip: {
      display: 'none',
      position: 'absolute',
      top: '20px',
      left: '20px',
      backgroundColor: '#fff',
      border: `1px solid ${accentColor}`,
      width: '280px',
      borderRadius: '4px',
      padding: '16px',
      color: '#1D1D1D',
      zIndex: 1,
      fontSize: '9px',
    },
    tooltipContent: {
      '&:not(:first-child)': {
        marginTop: '10px',
      },
    },
    tooltipBlock: {
      '&:not(:last-child)': {
        marginBottom: '10px',
      },
    },
    tooltipTitle: {
      fontWeight: 'bold',
      color: accentColor,
    },
  }
}
